import { Injectable } from '@angular/core';
import { Keys } from '../etc/keys';

export enum Policy {
  Origin,
  Edit,

};
@Injectable()
export class KeycodeService {

  

constructor() { }

  isDateKey(evt) { // For YYYY-MM-DD format check
    if ((evt instanceof KeyboardEvent) === false) {
      return true;
    }
    const charCode = (evt.which) ? evt.which : evt.keyCode;
    if (charCode === 8 || charCode === 46) { // BackSpace
      return true;
    } else if (charCode === 37 || charCode === 39) { // Arrow Left / Right
      return true;
    } else if (charCode === 189
              ||
              (evt.location && evt.location === 3 && charCode === 109)) { // '-'
      return true;
    }

    // Select All
    if (evt.ctrlKey && (charCode === 65 || charCode === 97)) {
      return true;
    }

    if (!evt.shiftKey && !evt.ctrlKey && !evt.altKey && !evt.metaKey) {
      if (
          (charCode >= 48 && charCode <= 57)
          ||
          (evt.location && evt.location === 3 // NumPad
              && (charCode >= 96 && charCode <= 105))
        ) { // 0-9
        return true;
      }
    }

    if (evt.key === 'Tab') {
      return true;
    }

    return false;
  }

  isControlKey(evt) {
    const keyCode = (evt.which) ? evt.which : evt.keyCode;
    if ((evt instanceof KeyboardEvent) === false) {
      return false;
    }

    if (keyCode === Keys.Esc
        || keyCode == Keys.Shift
        || keyCode == Keys.Ctrl
        || keyCode == Keys.Alt
        || keyCode == Keys.CapsLock) {
          return true;
        }
    return false;
  }

  isArrowKey(evt) {
    const keyCode = (evt.which) ? evt.which : evt.keyCode;
    if ((evt instanceof KeyboardEvent) === false) {
      return false;
    }

    if (keyCode === Keys.Left
        || keyCode === Keys.Up
        || keyCode === Keys.Right
        || keyCode === Keys.Down) {
          return true;
        }
    return false;
  }

  isLongArrowKey(evt) {
    const keyCode = (evt.which) ? evt.which : evt.keyCode;
    if ((evt instanceof KeyboardEvent) === false) {
      return false;
    }

    if (keyCode === Keys.Home
        || keyCode === Keys.End
        || keyCode === Keys.PageUp
        || keyCode === Keys.PageDown) {
          return true;
        }
    return false;
  }

  isEditKey(evt) {
    const keyCode = (evt.which) ? evt.which : evt.keyCode;
    if ((evt instanceof KeyboardEvent) === false) {
      return false;
    }

    if (keyCode === Keys.BackSpace
       || keyCode === Keys.Delete
       || keyCode === Keys.Tab
       || keyCode === Keys.Enter
       || this.isArrowKey(evt)
       || this.isLongArrowKey(evt)
       || ((evt.ctrlKey || evt.shiftKey) && keyCode === Keys.A) // Select All
       || ((evt.ctrlKey || evt.shiftKey) && (this.isArrowKey(evt) || this.isLongArrowKey(evt))) // Select by cursor
      ) {
        return true;
    }
    return false;
  }

  isNumberKey(evt) {
    return this.isNumberKeyWithPolicy(evt, Policy.Edit);
  }

  isNumberKeyWithPolicy(evt, type?: Policy) {
    const keyCode = (evt.which) ? evt.which : evt.keyCode;
    if ((evt instanceof KeyboardEvent) === false) {
      return false;
    }

    if (type === Policy.Edit) {
      if (this.isEditKey(evt)) {
        return true;
      }
    }

    if ((keyCode > Keys.Num0 && keyCode < Keys.Num9)
        || (keyCode > Keys.NumPad0 && keyCode < Keys.NumPad9)) {
      return true;
    }
    
    if (keyCode > 31 && (keyCode < 48 || keyCode > 57)) {
      if (!(keyCode >= 96 && keyCode <= 105)) {
        return false;
      }
    }
    return true;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/service/keycode.service.ts